// Variant to form.js for builder forms that use recaptcha, without a global
// recaptcha for DB forms. Used on the musical verticals only, for now.
export default class RecaptchaHandler {
    constructor($form) {
        this.$el = $form;
        this.$captchaInput = this.$el.querySelector('[name="g-recaptcha-response"], [data-recaptcha]');
        this.useCaptcha = this.$captchaInput;
        this.submitted = false;

        this.submit = this.submit.bind(this);
        this.captcha = this.captcha.bind(this);

        // Prevent multiple form submits
        this.$el.addEventListener('submit', this.submit);
    }

    submit(e) {
        e.preventDefault();

        if (this.submitted) {
            return false;
        }

        this.captcha(() => {
            this.submitted = true;
            this.$el.submit();
        });
    }

    captcha(callback) {
        if ( ! this.useCaptcha) {
            callback();
            return;
        }
        grecaptcha.enterprise.ready(() => {
            grecaptcha.enterprise.execute(this.$captchaInput.dataset.key, {action: 'homepage'}).then( (token) => {
                this.$captchaInput.value = token;
                callback();
            });
        });
    };
}